const ITEM_ROUTES = {
  answer: { segment: 'answers', label: 'answer' },
  event: { segment: 'events', label: 'event' },
  template: { segment: 'blocks', label: 'block' }
}

function encodePathSegment(id) {
  return encodeURIComponent(String(id)).replace(/[!'()*]/g, character =>
    `%${character.charCodeAt(0).toString(16).toUpperCase()}`
  )
}

export function getKnowledgeBaseDeleteErrorLink(error) {
  const reference = error?.response?.data?.details?.errors?.[0]?.reference
  if (!reference?.botId) return null

  const botId = encodePathSegment(reference.botId)
  if (reference.itemType === 'bot') {
    return `<a href="/settings/bots/${botId}" target="_blank" rel="noopener noreferrer">Open bot</a>`
  }

  if (!Object.prototype.hasOwnProperty.call(ITEM_ROUTES, reference.itemType) || !reference.itemId) return null
  const route = ITEM_ROUTES[reference.itemType]

  const itemId = encodePathSegment(reference.itemId)
  return ` <a href="/bots/${botId}/${route.segment}/${itemId}" target="_blank" rel="noopener noreferrer">Open ${route.label}</a>`
}
